<template>
  <UserCommonLayout v-if="isLoading" :data-tour="userStore.isMemberType ? 'dashboard-candidate-credit' : 'dashboard-admin-credit'">
    <template #content>
      <LazyUserCommonContent
          :is-having-org="isHavingOrg"
          :my-assessment-list="myAssessmentList"
          :sample-assessment-list="sampleAssessments"
      />
    </template>
  </UserCommonLayout>
</template>

<script setup lang="ts">
import {LazyUserCommonContent, UserCommonLayout} from '#components';
import {useUserStore} from '~/store/user/userStore';
import {useLoadingStore} from '~/store/loading/loadingStore';
import {UserV2Type} from '~~/package/mapper/user/model/UserType';
import {ProSkillAssureMyAssessmentModel} from '~~/package/mapper/proSkillAssure/model/ProSkillAssureMyAssessmentModel';
import {useProSkillAssureService} from '~~/application/composables/service/useProSkillAssureService';
import type {
  ProSkillAssureSampleAssessmentModel
} from '~~/package/mapper/proSkillAssure/model/ProSkillAssureSampleAssessmentModel';

const {$i18n} = useNuxtApp();
const lang = computed(() =>
    $i18n.locale.value.toUpperCase()
);

const userStore = useUserStore();
const loadingStore = useLoadingStore();
const router = useRouter();

const userType = ref<UserV2Type | null>(null);
const myAssessmentList = ref<ProSkillAssureMyAssessmentModel[]>([]);
const sampleAssessments = ref<ProSkillAssureSampleAssessmentModel[]>([]);
const isLoading = ref(false);

const isHavingOrg = computed(() => !!userStore.userV2.orgInfo);
const isAdmin = computed(() => {
  return userStore.isAdminType || userStore.isSuperAdminType;
})

// ASMT-CAND-16: 대시보드 My assessments — 최근 초대 평가 상위 3건 노출
const initData = async () => {
  const [my, sample] = await Promise.all([
    useProSkillAssureService().getMyAssessmentList(1, 3, undefined, isAdmin.value)
        .catch((e) => (console.error(e), {data: []})),
    useProSkillAssureService().getSampleAssessmentList(lang.value, 1, 9999)
        .catch((e) => (console.error(e), {data: []}))
  ]);

  myAssessmentList.value = my.data;
  sampleAssessments.value = sample.data.slice(0, 3);

  loadingStore.closeLoading();
  isLoading.value = true;
};


onMounted(() => {
  if (userStore.isLogin()) {
    loadingStore.openLoading('light');

    if (!userStore.userV2.location) router.replace({path: '/register/info'});
    else loadingStore.closeLoading();

    userType.value = userStore.userV2.orgInfo?.grades[0] as UserV2Type ?? null;
    initData();
  } else {
    router.replace({path: '/'});
  }
});

watch($i18n.locale, () => {
  initData();
});
</script>
